import { Conversation } from 'ha/services/apiV2/types/Conversation';
import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

interface Payload {
  reason: string;
}

export default (makeCall: MakeCall) => (
  conversationId: number,
  data: Payload,
) =>
  makeCall<Conversation>(
    'PUT',
    `${APIV2_URL}/conversation/${conversationId}/decline`,
    { data },
  );
